<div class="container-botones">
    <div class="grids">
      <img src="assets/vodafone.png" class="img-logo" alt="Imagen de cabecera" />
    </div>
    <div class="flex align-items-center justify-content-center grids">
        <label class="style-lable"><strong>{{cabecera}}</strong></label>
    </div>
    <div class="flex align-items-center justify-content-end grids" style="padding-right: 10px;">
      <p-button [outlined]="true"[rounded]="true" [text]="true" severity="danger" (click)="logout()"
      label="Cerrar Sesión" icon="pi pi-sign-out" [ngStyle]="{'background-color': 'white', 'border-color': 'red', 'border-radius': '50px'}"/>
    </div>
 </div>